<template lang='pug'>
  blue-layout( :user='user' :account='account' :biz='biz' )
    template( v-slot:default='props' )
      bf-notice( @close='message = ""' :message='message' )

      base-modal( :show='popup.rprog' )
        modal-wrapper.max( @close='close' )
          template( v-slot:header )
            h4 {{ $t("BLUEFAUCET REFERRAL AGREEMENT") }}
          template( v-slot:contents )
            referral-agreement

      base-modal( :show='modal.refer' )
        referral-form(
          :referrals='referrals' 
          :user='user'
          :account='account'
          :biz='biz'
          type='merchant-invitation'
          @close='modal.refer = false'
        )

      #referrals.view
        bf-wrapper
          h2 {{ $t('Referral Program') }}

        bf-wrapper.container(v-if="account.referralagree")
          p.text {{ $t("If you like our service, make sure to introduce it to the merchants you visit.") }}
          p.link( v-if='user && user.uid' ) 
            label.notable {{$t("Dedicated URL to send the invitation: ")}}
            span http://app.bluefaucet.com/f/{{user.uid}}
            span.copy-icon.actionable( v-clipboard='`https://app.bluefaucet.com/f/${user.uid}`' @click="copymsg")
              img(src='/ui/copy.svg' width='20')

          bf-divider.section.borderless
          
          .totals
            p.total
              label Total Commission Paid Up-to-Date: 
              span.value ${{ paid }}
            p.total
              label Outstanding Commission: 
              span.value ${{ outstanding }}
            p.total
              label Amount to Withdraw: 
              span.value ${{ withdrawable }}
            p ($30 processing fee if under $200)
              
          bf-divider.section.borderless

          bf-flex.paypal
            label Commission pay to (PayPal)
            input( type='email' :value='account.paypal' @blur='paypalize' )
            bf-button.basic( v-if='requestable' @click.native='request' )
              template( v-slot:text ) Request Payment

          bf-divider.borderless.card

          bf-button.wide( @click.native='modal.refer = true' )
            template( v-slot:text ) {{ $t('Invite Merchant') }}

          table( :key='key' )
            tr
              th {{ $t('Name') }}
              th {{ $t('Email') }}
              th {{ $t('Date') }}
              th {{ $t('Merchant Status') }}
              th {{ $t('Commission Status') }}
                
            tr( v-for='item in referrals' :key='item.id' )
              td {{ item.to.name || 'Not Entered' }}
              td {{ item.to.email }}
              td {{ item.on ? item.on.toDate().toLocaleString() : 'N/A' }}
              td {{ status( item ).mer }}
              td {{ status( item ).com }}

        bf-wrapper.container( v-else )
          p.text {{ $t("If you like our service, make sure to introduce it to the merchants you visit.") }}
          H5 {{$t("Please review our Referral Agreement")}}
          span {{$t("Step 1")}}:
            bf-button.agree( @click.native='showrprog' )
              template( v-slot:text ) {{$t("Review Referral Agreement")}}
          span {{$t("Step 2")}}:
            bf-button.agree( @click.native='seen' )
              template( v-slot:text ) {{$t("I Agree")}}
</template>

<script>
  import { View } from '@/mixins/view'
  import { db, fc } from '@/main'
  import ReferralForm from '@/components/forms/referral'
  import BaseModal from '@/components/modals/base'
  import ModalWrapper from '@/components/modals/wrapper'
  import ReferralAgreement from '@/components/modals/referral-agreement'

  export default {
    name: 'referrals.view',

    mixins: [ View ],

    props: [ 'user', 'account', 'biz', 'applications', 'csts', 'modals' ],

    components: {
      ReferralForm,
      BaseModal,
      ModalWrapper,
      ReferralAgreement
    },

    data() {
      return {
        key: 0,
        message: '',
        modal: { refer: false },
        referrals: [],
        referralagree: false,
        popup: { rprog: false },
        accs: [],
        invoices: []
      }
    },

    firestore() {
      if ( this.user && this.user.uid ) return {
        referrals: { 
          ref: db.collection( 'referrals' ).where( 'by.id', '==', this.user.uid )
        },

        accs: {
          ref: db.collection( 'accounts' ),
        }
      }
    },

    computed: {
      pending() {
        return this.account.requests && this.account.requests.filter( r => !r.paid )
      },

      requestable() {
        return this.outstanding > 30 && !this.account.requested  && !this.pending
      },

      total() {
        let totals = []
        this.referrals.forEach( r => {
          let acc = null
          if ( r.to ) {
            if ( r.to.id ) acc = this.accs.find( a => a.id == r.to.id )
            else acc = this.accs.find( a => a.email == r.to.email )
          }
          else {
            acc = this.accs.find( a => a.id == r.uid )
          }

          if ( acc ) {
            totals.push( this.invoices.filter( inv => inv.customer == acc.stripe_id ).length )
          }
        })
        return totals.reduce( ( a, b ) => a + b ,  0 ) * 15
      },

      outstanding() {
        return this.referrals.filter( r => !r.paid ).map( r => r.request.amount ).reduce( ( a, b ) => a + b, 0 )
      },

      paid() {
        return this.referrals.filter( r => r.paid ).map( r => r.request.amount ).reduce( ( a, b ) => a + b, 0 )
        // console.log(this.referrals.filter( r => r.paid ).map( r => r.request.amount ).reduce( ( a, b ) => a + b, 0 ));
      },

      withdrawable() {
        return this.outstanding - this.paid - this.fee
      },

      fee() {
        return this.outstanding >= 200 ? 0 : 30
      }
    },

    watch: {
      user( curr, prev ) {
        if ( curr && curr.uid ) {
          this.$binding( 'referrals',  db.collection( 'referrals' ).where( 'by.id', '==', curr.uid ) )
          this.$binding( 'accs', db.collection( 'accounts' ) )
        }
      }
    },
    
    methods: {
      request() {
        if ( !this.account.paypal ) alert( 'Please enter a paypal address' )

        else if ( this.outstanding <= 30 ) alert( 'An outstanding balance above $30 is required for an early payout request' )

        else {
          let requests = this.account.requests || []
          requests.push({ 
            on: new Date(), 
            outstanding: this.outstanding, 
            amount: this.outstanding - 30,
            refs: this.referrals
          })
          db.collection( 'accounts' ).doc( this.user.uid ).update({
            requests
          })
        }
      },

      canceled( invoices ) {
        let latest = invoices.sort( ( a, b ) => b.created - a.created )[0]
        return new Date() / 1000 - latest.created > 2678400
      },

      subscriptions( acc ) {
        let invoices = this.invoices.filter( inv => inv.customer == acc.stripe_id )
        let count = invoices.length

        switch ( count ) {
          case 1:
            if ( this.canceled( invoices ) ) return 'Cancel before 2nd month'
            else return 'Merchant'
          case 2:
            return 'Paid 2nd Month'
          default:
            return 'Paid 2nd Month'
        }
      },

      status( r ) {
        switch( r.status ) {
          case 'invited':
            return { mer: 'Invitation Sent', com: 'NA' }
          
          case 'user':
            return { mer: 'Signup', com: 'NA' }

          case 'merchant':
            let acc = this.accs.find( a => a.id  == r.to.id )
            if ( acc ) return { 
              mer:  acc.merchant == 'value' ? this.subscriptions( acc ) : 'Basic Seller', 
              com: r.paid ? `$15 (paid ${r.paid.on.toDate().toLocaleDateString()})` : '$15 (outstanding)' }
            else return { mer: 'Unknown', com: 'NA' }

          default:
            return { mer: 'unknown', com: 'unknown' }
        }
      },

      paypalize( e ) {
        db.collection( 'accounts' ).doc( this.account.id ).update({ paypal: e.target.value })
      },

      seen() {
        db.collection( 'accounts' ).doc( this.account.id ).update({ referralagree: true })
      },
      copymsg(){
        alert(this.$t('URL copied to clipboard'))  
      },
      close() {
        this.popup.rprog = false
      },
      showrprog() {
        this.popup.rprog = true
      }
    },

    created() {
      fc.httpsCallable( 'all_invoices' )().then( r => this.invoices = r.data )
    }
  }
</script>

<style scoped lang='stylus'>
  .totals
    font-size 1.2em
    font-weight bold
    .total
      margin 32px 0
      .value
        color blue
        margin-left 8px
  #referrals
    .paypal
      align-items center
      label
        // margin-right 16px

      input
        border 1px solid rgb( 200 200 200 )
        border-radius 5px
        padding 4px 8px
        margin 0 16px
    p
      margin-bottom 10px
    .agree
      margin-top 20px
      margin-left 20px
      margin-right 20px
    .heading
      padding-bottom 0
      padding-left 64px
      padding-right 64px
    table
      margin-top 10px
      background white
      border 1px solid lightgray
      width 100%
      tr
        border-bottom 1px solid
      th, td
        padding 8px 12px
        text-align center
        &:first-child
          text-align left
        &:last-child
          text-align right
      th
        font-size 1.1em
        font-weight bold
      .bf-button
        margin-left 16px
  .copy-icon	
    position absolute	
    margin-left 20px
  .text
    font-size 1.1em
    margin-bottom 10px
  .link
    font-size 1.2em
    font-weight bold
    color blue
    font-decoration underline 
    margin-top 10px
    label, span
      display inline-block
    label
      margin-right 12px
    span
      color var(--clr-blue-light)
</style>
